/** Central app name. The name of the original trademarked game must never appear in UI, titles or assets. */
export const APP_NAME = "Grundbesitz";

export const CURRENCY = "M";

export const MAX_PLAYERS = 8;
export const MIN_PLAYERS = 2;
export const ROOM_CODE_LENGTH = 6;
/** No 0/O/1/I/L to avoid look-alikes. */
export const ROOM_CODE_ALPHABET = "ABCDEFGHJKMNPQRSTUVWXYZ23456789";

export const BOARD_SIZE = 40;
export const GO_SALARY = 200;
export const JAIL_POSITION = 10;
export const GO_TO_JAIL_POSITION = 30;
export const FREE_PARKING_POSITION = 20;
export const JAIL_FINE = 50;
export const MAX_JAIL_ATTEMPTS = 3;
export const DEFAULT_STARTING_CASH = 1500;
export const TOTAL_HOUSES = 32;
export const TOTAL_HOTELS = 12;
export const MIN_AUCTION_BID = 10;
export const MORTGAGE_INTEREST_PERCENT = 10;

export const AUCTION_COUNTDOWN_MS = 10_000;
export const BUILD_WINDOW_MS = 5_000;
export const DISCONNECT_AUTOPLAY_MS = 90_000;
export const CHAT_MAX_LENGTH = 300;
export const NAME_MAX_LENGTH = 20;

export const TOKENS = [
  "hat",
  "thimble",
  "iron",
  "battleship",
  "boot",
  "wheelbarrow",
  "dog",
  "racecar",
  "cat",
  "dinosaur",
  "duck",
  "penguin",
] as const;
export type TokenId = (typeof TOKENS)[number];

export const TOKEN_NAMES: Record<TokenId, string> = {
  hat: "Zylinder",
  thimble: "Fingerhut",
  iron: "Bügeleisen",
  battleship: "Schlachtschiff",
  boot: "Schuh",
  wheelbarrow: "Schubkarre",
  dog: "Hund",
  racecar: "Rennwagen",
  cat: "Katze",
  dinosaur: "Dinosaurier",
  duck: "Ente",
  penguin: "Pinguin",
};

/** Eight player colors, picked to stay distinguishable in light and dark mode. */
export const PLAYER_COLORS = [
  { id: "red", name: "Rot", hex: "#e5484d" },
  { id: "blue", name: "Blau", hex: "#3e63dd" },
  { id: "green", name: "Grün", hex: "#30a46c" },
  { id: "amber", name: "Gelb", hex: "#f5b400" },
  { id: "violet", name: "Violett", hex: "#8e4ec6" },
  { id: "cyan", name: "Türkis", hex: "#05a2c2" },
  { id: "pink", name: "Pink", hex: "#d6409f" },
  { id: "gray", name: "Grau", hex: "#6b7280" },
] as const;
export type PlayerColorId = (typeof PLAYER_COLORS)[number]["id"];
export const PLAYER_COLOR_IDS = PLAYER_COLORS.map((c) => c.id) as PlayerColorId[];

/** Bot strength, chosen per bot in the lobby. */
export const BOT_LEVELS = ["easy", "normal", "hard"] as const;
export type BotLevel = (typeof BOT_LEVELS)[number];

export const BOT_LEVEL_NAMES: Record<BotLevel, string> = { easy: "Leicht", normal: "Normal", hard: "Schwer" };

/** Bots answer a chain of counter offers at most this often before they reject. */
export const MAX_BOT_COUNTER_ROUNDS = 3;

export const EMOJI_REACTIONS = ["👍", "😂", "😮", "😡", "🎉", "💸", "🤝", "😭"] as const;
